import { FlexRow, Panel, Tag, Text } from '@epam/promo';
import {
  Industry,
  ISkilloTech,
} from 'modules/project-list/components/project-card/modal';
import './styles.scss';

interface Props {
  technologies: ISkilloTech[];
  industries?: Industry[];
}

export const ProjectTags = (props: Props) => (
  <Panel cx="project-detail-tags">
    <Text
      fontSize={'16'}
      lineHeight={'24'}
      font={'museo-sans'}
      cx="project-tags-header"
    >
      Industries & Technologies
    </Text>
    {props.industries && props.industries?.length > 0 && (
      <FlexRow alignItems="center" spacing="12" cx="project-tags">
        {props.industries?.map((item) => (
          <Tag
            key={item.id}
            caption={item.name}
            size="24"
            cx="project-detail-tag project-detail-industry"
          ></Tag>
        ))}
      </FlexRow>
    )}
    {props.technologies.length > 0 && (
      <FlexRow alignItems="center" spacing="12" cx="project-tags">
        {props.technologies.map((tech) => (
          <Tag
            key={tech.skilloId}
            size="24"
            caption={tech.name}
            cx="project-detail-tag project-detail-tech"
          />
        ))}
      </FlexRow>
    )}
  </Panel>
);
